import 'babel-polyfill';
import 'redux';
import 'angular';
import 'ng-redux';
import 'angular-ui-router';
import 'angular-ui-bootstrap';
import 'angular-animate';
import 'angular-cookies';
import 'angular-messages';
import 'angular-aside';
import 'angularjs-toaster';
import 'angular-ui-mask';
import 'angular-spinners';
import 'ng-file-upload';
import 'ngmap';
import 'angular-ui-validate';
import 'angulartics';
import 'angulartics-google-analytics';




// WEBPACK FOOTER //
// ./src/vendor.js